import React, { useEffect, useState } from "react";
import { Button, Modal, Col, Row, Nav } from "react-bootstrap";
import useReactRouter from "use-react-router";
import "bootstrap/dist/css/bootstrap.min.css";
import * as _ from "lodash";
import { useInitFbSDK } from "../../helpers/fb-hooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Lottie from "lottie-react";
import {
  faVideo,
  faPlus,
  faExclamationCircle,
  faAdd,
} from "@fortawesome/free-solid-svg-icons";
import { faYoutube } from "@fortawesome/free-brands-svg-icons";
import { COLOR_APP } from "../../constants";
import { errorTitleWithTextSwal } from "../../helpers/sweetalert";
import moment from "moment";
import Swal from "sweetalert2";
import { useToasts } from "react-toast-notifications";
import "./liveScreen/liveScreen.css";
import { GET_LIVES } from "../../graphql/live/query";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { DELETE_LIVE, UPDATE_LIVE } from "../../graphql/live/mutation";
import { GET_LIVE_STOCKS } from "../../graphql/liveStock/query";
import { UPDATE_STOCK } from "../../graphql/stock/mutation";
import { SHOP } from "../../graphql/shop/queryShop";
import { GET_SETTINGS, GET_SETTING_BY_SHOP } from "../../graphql/setting/query";
import {
  END_LIVE,
  SEND_NOTI_TO_CUSTOMER,
  UNSUBSCRIBE_LIVE,
} from "../../graphql/liveManage/subscribeLive";
import { connect } from "react-redux";
import useWindowDimensions from "../../helpers/useWindowDimensions";
// import shoppingAnimation from "../../image/shopping.json";
import shoppingAnimation from "../../image/sopping.json";

import LiveHistory from "./liveHistory/LiveHistory";
import LiveActive from "./liveActive/LiveActive";
import { FaWhatsapp } from "react-icons/fa";
import { MdClose } from "react-icons/md";
import PackageNotPermission from "../../components/currentComponent/PackageNotPermission";

function LiveMange({ fbdata: { assignedPageList } }) {
  const { addToast } = useToasts();
  const { history, match } = useReactRouter();
  const isFbSDKInitialized = useInitFbSDK();

  const LIMIT_PAGE = 30;

  // App state
  const [fbUserAccessToken, setFbUserAccessToken] = useState();
  const [liveList, setLiveList] = useState([]);
  const [liveTotal, setLiveTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showGuide, setShowGuide] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteData, setDeleteData] = useState();
  const [currentStatus, setCurrentStatus] = useState("ALL");
  const [currentList, setCurrentList] = useState(match?.params?.liveType);
  const [showDeleteLiveConfirm, setShowDeleteLiveConfirm] = useState(false);
  const [showDeleteLiveSuccess, setShowDeleteLiveSuccess] = useState(false);



  //ERROR CHECK
  const [selectedLive, setSelectedLive] = useState();
  const [isContinue, setIsContinue] = useState(false);

  //Pagination
  const [pageNumber, setPageNumber] = useState(1);
  const [pageCountNumber, setPageCountNumber] = useState(1);
  let shopIdIn = localStorage.getItem("SHOP");
  const [isModalLess, setIsModalLess] = useState(false)


  const [shopValidated, setShopValidated] = useState();
  const [liveShopStockForValidate, setLiveShopStockForValidate] = useState();

  const [getLivesData, { data: livesData }] = useLazyQuery(GET_LIVES, {
    fetchPolicy: "cache-and-network",
  });
  const [getLiveShopStock, { data: liveShopStockDataForDelete }] = useLazyQuery(
    GET_LIVE_STOCKS,
    { fetchPolicy: "cache-and-network" }
  );
  const [getLiveShopStockForValidate, { data: liveShopStockDataForValidate }] =
    useLazyQuery(GET_LIVE_STOCKS, { fetchPolicy: "cache-and-network" });
  const [getShop, { data: shopValidatedData }] = useLazyQuery(SHOP, {
    fetchPolicy: "cache-and-network",
  });
  const [getShopSetting, { data: shopSettingData }] = useLazyQuery(
    GET_SETTINGS,
    { fetchPolicy: "cache-and-network" }
  );


  // setting by shop
  const { data: settingData } = useQuery(GET_SETTING_BY_SHOP, {
    fetchPolicy: "network-only",
    variables: {
      where: {
        shop: shopIdIn,
      },
    },
  });

  const [deleteLive] = useMutation(DELETE_LIVE);
  const [updateStock] = useMutation(UPDATE_STOCK);
  const [updateLive] = useMutation(UPDATE_LIVE);
  const [unsubscribeLive] = useMutation(UNSUBSCRIBE_LIVE);
  const [endLiveVDO] = useMutation(END_LIVE);
  const [sendNotiToCustomer] = useMutation(SEND_NOTI_TO_CUSTOMER);

  // Checks if the user is logged in to Facebook
  useEffect(() => {
    getLives();
    getFacebookLoginStatus();

  }, []);

  // fetch data setting by shop
  useEffect(() => {

    if (settingData) {
      if (settingData?.settingByShopId?.orderPoint <= 1 && settingData?.settingByShopId?.isLimitedOrder) {
        setIsModalLess(true)
      }
    }
  }, [settingData]);

  React.useEffect(() => {
    if (isFbSDKInitialized) {
      window.FB.getLoginStatus((response) => {
        if (response.authResponse)
          setFbUserAccessToken(response.authResponse?.accessToken);
        else
          errorTitleWithTextSwal(
            "ມີຂໍ້ຜິດພາດ",
            "ໃນການເຂົ້າສູ່ລະບົບດ້ວຍເຟສບຸກ ລອງໃຫມ່ອີກຄັ້ງ"
          );
      });
    }
    // getLives();
  }, [isFbSDKInitialized]);

  useEffect(() => {
    if (shopValidatedData) {
      //Check error point
      if (shopValidatedData?.shop?.paymentType == "POINT") {
        if (shopValidatedData?.shop?.point <= 0) {
          setIsLoading(false);
          Swal.fire({
            icon: "error",
            title: "ຄະແນນຂອງທ່ານບໍ່ພຽງພໍ!",
            html:
              `<div className="text-left">ກະລຸນາເຕີ່ມຄະແນນກ່ອນ ຈຶ່ງສາມາດເລີ່ມຕໍ່ການ Live ໄດ້ <br/>` +
              "ຕິດຕໍ່ຫາພວກເຮົາ ເພື່ອເຕີມຄະແນນ ຫຼື ປ່ຽນເພັກເກັດໃໝ່ໃນການນຳໃຊ້ລະບົບ<br/>" +
              "</div>",
            showConfirmButton: false,
            timer: 20000,
          });
          return;
        }
      }

      //Check If Subscription period
      if (shopValidatedData?.shop?.paymentType == "SUBSCRIPTION") {
        if (moment().diff(shopValidatedData?.shop?.endDate, "days") > 0) {
          setIsLoading(false);
          Swal.fire({
            icon: "error",
            title: "ໄລຍະເວລາການໃຊ້ງານຂອງທ່ານສິ້ນສຸດແລ້ວ!",
            html:
              `<div className="text-left">` +
              "ຕິດຕໍ່ຫາພວກເຮົາ ເພື່ອເຕີມຄະແນນ ຫຼື ປ່ຽນເພັກເກັດໃໝ່ໃນການນຳໃຊ້ລະບົບ<br/>" +
              "</div>",
            showConfirmButton: false,
            timer: 20000,
          });
          return;
        }
      }

      /**
       * Check live product is not delete from warehouse
       */
      getLiveShopStockForValidate({
        variables: {
          where: {
            live: selectedLive?.id,
          },
        },
      }).then(() => setLiveShopStockForValidate(!liveShopStockForValidate));
    }
  }, [shopValidated]);

  useEffect(() => {
    try {
      if (liveShopStockDataForValidate) {
        /**
         * Check if live has no liveproduct will not allow to start live
         */
        let _liveStockList = liveShopStockDataForValidate?.liveStocks?.data;

        if (_liveStockList?.length == 0) {
          Swal.fire({
            icon: "error",
            title: "ບໍ່ມີສິນຄ້າທີ່ຈະຂາຍໃນໄລຟ",
            html:
              `<div className="text-left">STEP1: ເພີ່ມສິນຄ້າທີ່ຈະຂາຍໃນໄລຟນີ້ກ່ອນ<br/>` +
              "STEP2 : ເລີ່ມໄລຟຂາຍເຄື່ອງໄດ້ເລີຍ <br/>" +
              "</div>",
            showConfirmButton: false,
            timer: 20000,
          });
          setIsLoading(false);
          return;
        }

        /**
         * Check if stock does not exist in warehouse
         */
        let checkStockExistError = false;
        _liveStockList.map(async (lProduct) => {
          // console.log({ lProduct })
          if (lProduct?.stock?.isDeleted) {
            checkStockExistError = true;
          }
        });
        if (checkStockExistError) {
          Swal.fire({
            icon: "error",
            title: "ມີສິນຄ້າທີ່ຖືກລຶບອອກຈາກສະຕ໊ອກແລ້ວໃນໄລຟນີ້",
            html:
              `<div className="text-left">STEP1: ແກ້ໄຂໄລຟນີ້ ຫຼື ສ້າງໄລຟໃຫມ່<br/>` +
              "STEP2 : ລຶບສິນຄ້ານັ້ນອອກ <br/>" +
              "</div>",
            showConfirmButton: false,
            timer: 20000,
          });
          setIsLoading(false);
          return;
        }

        /**
         * Check if User is not login with facebook
         */
        if (!fbUserAccessToken) {
          Swal.fire({
            icon: "error",
            title: "ກະລຸນາເຊື່ອມຕໍ່ກັບ Facebook ກ່ອນ!",
            html:
              `<div className="text-left">STEP1: ກົດປຸ່ມ ເຊື່ອມFacebook ຢູ່ມຸມຂວາເທິງຂອງຫນ້ານີ້ <br/>` +
              "STEP2 : ປ້ອນຂໍ້ມູນບັນຊີຂອງເຟສບຸກຂອງທ່ານ <br/>" +
              "</div>",
            showConfirmButton: false,
            timer: 20000,
          });
          setIsLoading(false);
          return;
        }

        /**
         * Check if no page selected
         */
        if (!selectedLive?.page) {
          Swal.fire({
            icon: "error",
            title: "ເລືອກເພຈທີ່ທ່ານຕ້ອງການໄລຟສົດ",
            html:
              `<div className="text-left">STEP1: ເລືອກເພຈທີ່ຕ້ອງການໄລຟໃສ່ກັບຂໍ້ມູນທີ່ສ້າງມາ <br/>` +
              "" +
              "</div>",
            showConfirmButton: false,
            timer: 20000,
          });
          setIsLoading(false);
          return;
        }
        let _pageIndex = _.findIndex(assignedPageList, {
          id: selectedLive.page,
        });
        console.log(
          "assignedPageList[_pageIndex]",
          assignedPageList[_pageIndex]
        );
        if (assignedPageList[_pageIndex].isPrivate) {
          try {
            window.FB.api(
              `/${assignedPageList[_pageIndex].id}/live_videos?fields=title,id,live_status,status&access_token=${assignedPageList[_pageIndex].access_token}`,
              function (response) {
                if (response.error) {
                  console.log("FB ERROR:", response.error);
                  addToast(
                    "ຜິດພາດ ກະລຸນາເຊື່ອມ Facebook ໃຫມ່ແລ້ວລອງໃຫມ່ອີກຄັ້ງ!",
                    {
                      appearance: "warning",
                      autoDismiss: true,
                    }
                  );
                  setIsLoading(false);
                  return;
                }
                if (response && !response.error) {
                  console.log("{ response.data }", response.data);
                  let isLiveAvailable = false;
                  if (response.data) {
                    response.data.map((vdo) => {
                      if (vdo.status == "LIVE") isLiveAvailable = true;
                    });
                    setIsLoading(false);
                  }
                  if (isLiveAvailable)
                    history.push(`/live-screen/${selectedLive?.id}`, {
                      live: selectedLive,
                      page: assignedPageList[_pageIndex],
                      isContinue,
                    });
                  else {
                    setIsLoading(false);
                    return Swal.fire({
                      icon: "error",
                      title: "ບໍ່ມີໄລຟສົດໃນເພຈເທື່ອ!",
                      html:
                        `<div className="text-left">STEP1: ໄປທີ່ page (${assignedPageList[_pageIndex].name}) <br/> ` +
                        "STEP2 : ເລີ່ມໄລຟວິດີໂອແລ້ວລໍຖ້າຈົນກວ່າການກະກຽມນັ້ນສໍາເລັດ<br/>" +
                        "STEP3 : ກັບຄືນມາຫນ້ານີ້ແລ້ວກົດ ເລີ່ມໄລຟ ໄດ້ເລີຍ</div>",
                      showConfirmButton: false,
                      timer: 20000,
                    });
                  }
                }
              }
            );
            return;
          } catch (err) {
            setIsLoading(false);
            console.log(err);
            addToast("ຜິດພາດ ກະລຸນາເຊື່ອມ Facebook ໃຫມ່ແລ້ວລອງໃຫມ່ອີກຄັ້ງ!", {
              appearance: "warning",
              autoDismiss: true,
            });
            return;
          }
        } else {
          setIsLoading(false);
          window.FB.api(
            `/${assignedPageList[_pageIndex].id}/videos?fields=title,id,status,live_status&access_token=${assignedPageList[_pageIndex].access_token}`,
            function (response) {
              if (response.error) {
                console.log("FB ERROR:", response.error);
                addToast(
                  "ຜິດພາດ ກະລຸນາເຊື່ອມ Facebook ໃຫມ່ແລ້ວລອງໃຫມ່ອີກຄັ້ງ!",
                  {
                    appearance: "warning",
                    autoDismiss: true,
                  }
                );
                setIsLoading(false);
                return;
              }
              if (response && !response.error) {
                console.log("{ response.data }", response.data);
                let isLiveAvailable = false;
                if (response.data) {
                  response.data.map((vdo) => {
                    if (vdo.live_status == "LIVE") isLiveAvailable = true;
                  });
                  setIsLoading(false);
                }
                if (isLiveAvailable)
                  history.push(`/live-screen/${selectedLive?.id}`, {
                    live: selectedLive,
                    page: assignedPageList[_pageIndex],
                    isContinue,
                  });
                else {
                  setIsLoading(false);
                  Swal.fire({
                    icon: "error",
                    title: "ບໍ່ມີໄລຟສົດໃນເພຈເທື່ອ!",
                    html:
                      `<div className="text-left">STEP1: ໄປທີ່ page (${assignedPageList[_pageIndex].name}) <br/> ` +
                      "STEP2 : ເລີ່ມໄລຟວິດີໂອແລ້ວລໍຖ້າຈົນກວ່າການກະກຽມນັ້ນສໍາເລັດ<br/>" +
                      "STEP3 : ກັບຄືນມາຫນ້ານີ້ແລ້ວກົດ ເລີ່ມໄລຟ ໄດ້ເລີຍ</div>",
                    showConfirmButton: false,
                    timer: 20000,
                  });
                }
              }
            }
          );
        }
      }
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  }, [liveShopStockForValidate]);

  useEffect(() => {
    if (livesData) {
      setIsLoading(false);
      setLiveList(livesData?.lives?.data);
      setLiveTotal(livesData?.lives?.total);
      setPageCountNumber(parseInt(livesData?.lives?.total / LIMIT_PAGE) + 1);
    }
  }, [livesData]);

  useEffect(() => {
    onNextOrBackPage();
  }, [pageNumber]);

  useEffect(() => {
    getFacebookLoginStatus();
  }, [assignedPageList]);

  useEffect(() => {
    if (liveShopStockDataForDelete) {
      let _updateStockData = liveShopStockDataForDelete?.liveStocks?.data;
      _updateStockData.map((lStock, index) => {
        _updateStockWhenDelete(lStock);
      });
    }
  }, [liveShopStockDataForDelete]);

  const getLives = async () => {
    try {
      setLoading(true);
      let SHOP_ID = await localStorage.getItem("SHOP");
      await getLivesData({
        variables: {
          where: {
            shop: SHOP_ID,
            isDeleted: false,
          },
          limit: LIMIT_PAGE,
          skip: LIMIT_PAGE * (pageNumber - 1),
          orderBy: "createdAt_DESC",
        },
      });
      await getShopSetting({
        variables: {
          where: {
            shop: SHOP_ID,
          },
          orderBy: "createdAt_ASC",
        },
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("Error retrieving posts", error);
    }
  };

  const onNextOrBackPage = async () => {
    try {
      setIsLoading(true);
      let SHOP_ID = await localStorage.getItem("SHOP");

      let _where = {
        shop: SHOP_ID,
        isDeleted: false,
      };

      //check if status is selected
      if (currentStatus != "ALL") {
        _where = {
          ..._where,
          status: currentStatus,
        };
      }

      await getLivesData({
        variables: {
          where: _where,
          limit: LIMIT_PAGE,
          skip: LIMIT_PAGE * (pageNumber - 1),
          orderBy: "createdAt_DESC",
        },
      });
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const getFacebookLoginStatus = () => {
    try {
      window.FB.getLoginStatus((response) => {
        if (response.authResponse)
          setFbUserAccessToken(response.authResponse.accessToken);
      });
    } catch (error) {
      console.log("Error FACEBOOK STATUS", error);
    }
  };


  const checkPoint = async () => {
    try {
      const SHOP_ID = await localStorage.getItem("SHOP");
      await getShop({
        variables: {
          where: {
            id: SHOP_ID,
          },
        },
      }).then(() => setShopValidated(!shopValidated));
    } catch (error) {
      console.log("error: ", error);
    }
  };

  /***************************
   * Update Stock
   * Restore product amount when delete live
   **************************/
  const _updateShopStock = async () => {
    await getLiveShopStock({
      variables: {
        where: {
          live: deleteData?.id,
        },
        orderBy: "createdAt_DESC",
      },
    });
  };

  const _updateStockWhenDelete = async (lStock) => {
    await updateStock({
      variables: {
        where: {
          id: lStock?.stock?.id,
        },
        data: {
          amount: lStock?.stock?.amount + lStock?.amount,
          isUsing: false,
        },
      },
    });
  };

  const _deleteLive = async () => {
    if (isLoading) return;
    if (deleteData) {
      try {
        setIsLoading(true);
        if (deleteData.status != "COMPLETED") {
          /***************************
           * Update Stock
           * Restore product amount
           **************************/
          await _updateShopStock();
        }
        /***************************
         * Delete live record
         **************************/
        await deleteLive({
          variables: {
            where: {
              id: deleteData?.id,
            },
          },
        });
        let _liveList = [...liveList];
        _.remove(_liveList, { id: deleteData?.id });
        setLiveList(_liveList);
        setIsLoading(false);
        setShowDeleteModal(false);
        addToast("ລຶບໄລຟສໍາເລັດ", {
          appearance: "success",
          autoDismiss: true,
        });
        setDeleteData();
      } catch (err) {
        console.log(err);
        setIsLoading(false);
      }
    }
  };

  const _goToYoutube = () => {
    window.open("https://www.youtube.com/watch?v=AUZw4n44Dfo", "_blank");
  };

  const { height, width } = useWindowDimensions();

  const _goLiveScreen = async (live, isContinueA) => {
    setSelectedLive(live);
    setIsLoading(true);
    const _checkPoint = await checkPoint();
  };

  const handleCreateLiveNow = () => {
    if (settingData?.settingByShopId?.orderPoint <= 1 && settingData?.settingByShopId?.isLimitedOrder) {
      setIsModalLess(true)
      return;
    }
    history.push(`/live-add`, { editMode: false })
  }

  const handleCloseModalLess = () => {
    history.push(`/dashboard`)
    setIsModalLess(false)
  }


  // if (loading || isLoading) return <AnimationLoading />
  return (
    <div style={{ background: "#fff" }}>
      {width > 700 ? (
        <div style={{ padding: 0, margin: 0 }}>
          <div className="Contain">
            <div className="live-list">
              <div className="baner">
                <FontAwesomeIcon
                  icon={faVideo}
                  style={{
                    width: "32px",
                    height: "32px",
                    marginRight: "10px",
                  }}
                />
                <span style={{ fontSize: "22px" }}>ຈັດການໄລຟ</span>
              </div>
              <p>
                ສະແດງປະຫວັດການໄລຟສົດ
                ສ້າງໄລຟສົດເພື່ອທີ່ຈະເຊື່ອມຕໍ່ກັບການໄລຟສົດທີ່ເຟສບຸກ ແລະ
                ເບິ່ງຂໍ້ມູນການໄລຟພ້ອມສະຫຼຸບລາຍການສັ່ງຊື້ໃນໄລຟນັ້ນໆແບບລາຍການ ແລະ
                ສະຖິຕິ
              </p>
              <Button
                style={{
                  border: "none",
                  background: COLOR_APP,
                  color: '#fff',
                  padding: '.5em 1.5em',
                  borderRadius: '.3em'
                }}
                onClick={handleCreateLiveNow}>
                <FontAwesomeIcon
                  icon={faPlus}
                  style={{
                    color: "#FFFFFF",
                    fontSize: "16px",
                    paddingRight: "5px",
                  }}
                />
                ສ້າງໄລຟໃໝ່
              </Button>
            </div>

            <div style={{ marginRight: "72px" }}>
              <Lottie
                animationData={shoppingAnimation}
                loop={true}
                style={{
                  width: "247px",
                  height: "169px",
                }}
              />
            </div>
          </div>

          <div className="tab-live-manu" style={{ border: "none" }}>
            <div>
              <Nav
                variant="tabs"
                defaultActiveKey={match?.params?.liveType}
                style={{ border: "solid 0px" }}>
                <Nav.Item
                  style={{
                    borderBottom:
                      currentList === "active"
                        ? "3px solid #1c72d5"
                        : "1px solid #ddd",
                  }}>
                  <Nav.Link
                    eventKey="active"
                    onClick={() => {
                      history.push("/live-manage/active/limit/30/page/1");
                      setCurrentList("active");
                    }}
                    style={{
                      border: "solid 0px",
                      color: currentList === "active" ? "blue" : "#000000",
                    }}>
                    ລາຍການໄລຟ
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item
                  style={{
                    borderBottom:
                      currentList === "history"
                        ? "3px solid #1c72d5"
                        : "1px solid #ddd",
                  }}>
                  <Nav.Link
                    eventKey="history"
                    onClick={() => {
                      history.push("/live-manage/history/limit/30/page/1");
                      setCurrentList("history");
                    }}
                    style={{
                      border: "solid 0px",
                      color: currentList === "history" ? "blue" : "#000000",
                    }}>
                    ປະຫວັດການໄລຟ
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </div>
            {currentList === "active" ? (
              <LiveActive />
            ) : (
              <div>
                <LiveHistory />
              </div>
            )}
          </div>
        </div>
      ) : (
        <div>
          <div
            className="row"
            style={{
              display: "flex",
              marginTop: 60,
              marginLeft: 5,
              padding: "10px 0px",
              marginRight: 5,
            }}>
            <Col style={{ color: COLOR_APP, display: "flex" }}>
              <FontAwesomeIcon
                icon={faVideo}
                style={{
                  width: "30px",
                  height: "30px",
                  marginRight: 10,
                }}
              />
              <h5 style={{ margin: "2px 0px" }}>ຈັດການໄລຟ໌</h5>
            </Col>
            <Col>
              <Button
                onClick={handleCreateLiveNow}
                style={{
                  float: "right",
                  background: COLOR_APP,
                  borderRadius: 5,
                  borderColor: "#D9D9D9",
                  color: "#fff",
                  width: 105,
                  fontSize: 14,
                  fontWeight: "bold",
                  display: "flex",
                  justifyContent: "center",
                }}>
                <FontAwesomeIcon
                  icon={faAdd}
                  style={{
                    width: "13px",
                    height: "13px",
                    marginRight: 10,
                    alignSelf: "center",
                  }}
                />
                <h6 style={{ margin: "2px 0px", alignSelf: "center" }}>
                  ສ້າງໄລຟ໌
                </h6>
              </Button>
            </Col>
          </div>

          <div className="tab-live-manu" style={{ border: "none" }}>
            <div>
              <Nav
                variant="tabs"
                justify
                defaultActiveKey={match?.params?.liveType}
                style={{ border: "solid 0px" }}>
                <Nav.Item
                  style={{
                    borderBottom:
                      currentList === "active"
                        ? "3px solid #1c72d5"
                        : "1px solid #ddd",
                  }}>
                  <Nav.Link
                    eventKey="active"
                    onClick={() => {
                      history.push("/live-manage/active/limit/30/page/1");
                      setCurrentList("active");
                    }}
                    style={{
                      border: "solid 0px",
                      color: currentList === "active" ? "blue" : "#000000",
                    }}>
                    ລາຍການໄລຟ
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item
                  style={{
                    borderBottom:
                      currentList === "history"
                        ? "3px solid #1c72d5"
                        : "1px solid #ddd",
                  }}>
                  <Nav.Link
                    eventKey="history"
                    onClick={() => {
                      history.push("/live-manage/history/limit/30/page/1");
                      setCurrentList("history");
                    }}
                    style={{
                      border: "solid 0px",
                      color: currentList === "history" ? "blue" : "#000000",
                    }}>
                    ປະຫວັດການໄລຟ
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </div>
            {currentList === "active" ? (
              <LiveActive />
            ) : (
              <div>
                <LiveHistory />
              </div>
            )}
          </div>
        </div>

      )}

      <Modal
        show={showGuide}
        onHide={() => setShowGuide(false)}
        keyboard={false}
        dialogClassName="modal-90w modal-dialog2"
        aria-labelledby="example-custom-modal-styling-title"
        centered>
        <div
          className="text-center"
          style={{ background: "white", paddingLeft: 40, width: "89vw" }}>
          <Col>
            <Row>
              <img
                className="d-block"
                src={"/images/Tutorial-Live.jpg"}
                alt="Third slide"
                style={{ width: "100%" }}
              />
            </Row>
            <Row
              style={{
                background: "white",
                justifyContent: "end",
                paddingBottom: 16,
                paddingRight: 16,
              }}>
              <button
                className="btn btn-primary"
                style={{ width: 130, marginRight: 10 }}
                onClick={() => setShowGuide(false)}>
                ເຂົ້າໃຈແລ້ວ
              </button>

              <button
                className="btn btn-primary"
                style={{
                  background: "#E8EDF1",
                  color: "black",
                  width: 240,
                  height: 44,
                  marginLeft: 10,
                  display: "flex",
                  justifyContent: "space-evenly",
                }}>
                <p
                  style={{ paddingTop: 2 }}
                  onClick={(e) => {
                    _goToYoutube();
                    setShowGuide(false);
                  }}>
                  ເບິ່ງວິທີໃຊ້ງານທີ່ Youtube
                </p>
                <FontAwesomeIcon
                  icon={faYoutube}
                  style={{ width: 30, height: 30, color: "red" }}
                />
              </button>
            </Row>
          </Col>
        </div>
      </Modal>

      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <div>ຢືນຢັນການລຶບ</div>
        </Modal.Header>
        <Modal.Body
          style={{
            padding: 24,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}>
          <FontAwesomeIcon
            icon={faExclamationCircle}
            style={{ fontSize: 90, color: "orange" }}
          />
          <br />
          <h5>ທ່ານຕ້ອງການທີ່ຈະລຶບ Live ນີ້ແທ້ບໍ່?</h5>
        </Modal.Body>
        <Modal.Footer
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}>
          <Button
            variant="outline-dark"
            className="btn btn-app hoverme"
            style={{ width: width > 700 ? 150 : 100 }}
            onClick={() => setShowDeleteModal(false)}>
            ກັບຄືນ
          </Button>
          <div style={{ width: 24 }} />
          <button
            className="btn btn-app hoverme"
            style={{
              float: "left",
              background: "red",
              color: "#fff",
              width: width > 700 ? 150 : 100,
            }}
            onClick={() => _deleteLive()}>
            ລຶບ
          </button>
        </Modal.Footer>
      </Modal>

      <PackageNotPermission isModalLess={isModalLess} handleCloseModalLess={handleCloseModalLess} title="ຟັງຊັ່ນ Live" />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    fbdata: state.fbdata,
  };
};

export default connect(mapStateToProps)(LiveMange);
